<template>

 <v-autocomplete  
      v-model="country"
      ref="CountrySelector"
      :disabled="disabled"
      style="width:90px; min-width:90px; flex:0"
      @focus="isFocus = true"
      @blur="handleBlur"
 
      :items="countriesSorted"
      :filter="customFilter"
      hide-details
      solo
      class="mt-1"                  
      outlined
      flat
      append-icon="$chevrondown">
      <template v-slot:selection="{ item }">
        <span>+{{ item.dialCode }}</span>
      </template>
      <template v-slot:item="{ item }">
        <div class="countryTelCode">+{{item.dialCode}}</div>
        <div>{{item.label}}</div>
      </template>
    </v-autocomplete>
</template>

<script>
  import { VAutocomplete } from 'vuetify/lib'

  export default {
    name: 'CountrySelector',
    components: {
      VAutocomplete
    },
    props: {
      id: { type: String, default: 'CountrySelector' },
      value: { type: [String, Object], default: null },
      label: { type: String, default: 'Choose country' },
      hint: { type: String, default: String },
      size: { type: String, default: String },
      error: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      valid: { type: Boolean, default: false },
      dark: { type: Boolean, default: false },
      items: { type: Array, default: Array, required: true },
      preferredCountries: { type: Array, default: null },
      onlyCountries: { type: Array, default: null },
      ignoredCountries: { type: Array, default: null },
      countriesHeight: { type: Number, default: 35 },
      showCodeOnList: { type: Boolean, default: false }
    },
    data () {
      return {
        isFocus: false,
        hasListOpen: false,
        selectedIndex: null,
        tmpValue: this.value,
        indexItemToShow: 0,
        isHover: false
      }
    },
    computed: {
      countriesList () {
        let filtered = this.items
        .filter(item => !this.ignoredCountries.includes(item.iso2))
        .map(i => {
          i.label = this.$t(i.name)
          return i
        })
        .sort((a, b) => {
          if (a.label < b.label) { return -1 }
          if (a.label > b.label) { return 1 }
          return 0})

        return filtered
      },
      countriesFiltered () {
        const countries = this.onlyCountries || this.preferredCountries
        return countries.map(country => this.countriesList.find(item => item.iso2.includes(country)))
      },
      otherCountries () {
        return this.countriesList.filter(item => !this.preferredCountries.includes(item.iso2))
      },
      countriesSorted () {
        return this.preferredCountries
          ? [ ...this.countriesFiltered,
              ...this.otherCountries ]
          : this.onlyCountries
            ? this.countriesFiltered
            : this.countriesList
      },
      selectedValueIndex () {
        return this.value
          ? this.countriesSorted.findIndex(c => c.iso2 === this.value)
          : null
      },
      tmpValueIndex () {
        return this.countriesSorted.findIndex(c => c.iso2 === this.tmpValue)
      },
      country: {
        get () {
          return this.value ? this.countriesSorted.find(i => i.iso2 === this.value) : null
        },
        set (value) {
          if (value) this.updateValue(value.iso2)
        }
      }
    },
    methods: {
      updateHoverState(value) {
        this.isHover = value
      },
      handleBlur (e) {
        if (this.$el.contains(e.relatedTarget)) return
        this.isFocus = false
        this.closeList()
      },
      openList () {
        if (!this.disabled) {
          this.$refs.CountrySelector.focus()
          this.$emit('open')
          this.isFocus = true
          this.hasListOpen = true
          if (this.value) this.scrollToSelectedOnFocus(this.selectedValueIndex)
        }
      },
      closeList () {
        this.$emit('close')
        this.hasListOpen = false
      },
      async updateValue (val) {
        this.tmpValue = val
        this.$emit('input', val || null)
        await this.$nextTick()
        this.closeList()
      },
      scrollToSelectedOnFocus () {
        this.$nextTick(() => {
          // this.indexItemToShow = arrayIndex - 3
          // this.$refs.countriesList.scrollTop = arrayIndex * (this.countriesHeight + 1) - ((this.countriesHeight + 1) * 3)
        })
      },
      customFilter (item, queryText) {
        const textOne = item.label.toLowerCase()
        const textTwo = item.dialCode.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      }
    }
  }
</script>
